export default "__VITE_ASSET__c4a3f330__"